/* ================================================================
   AISTROWISE — Analytics bridge (deferred, no libraries)

   Single global listener that forwards every interaction tagged with
   `data-aw-event="<name>"` to window.dataLayer (GTM) and re-dispatches it
   as an `aw:track` DOM event. Buy CTAs across the new aw-* sections already
   carry these hooks:
     lectura_buy_click_{buscador|explorador|profundizador}
     ikigai_buy_click · sinastria_buy_click · astrocartografia_buy_click
     revolucion_solar_buy_click · eclipses_buy_click
     horoscopo_sub_click_{explorador|profundizador}
     bridge_click_lectura
   calculator_complete is pushed programmatically from aw-calculadora.js
   (it carries NO birth data).

   The push is synchronous, so the event lands in the dataLayer before a
   form POST unloads the page. No PII is ever attached here.
   ================================================================ */
(function () {
  'use strict';

  function push(name, extra) {
    if (!name) return;
    var payload = { event: name };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; } }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('aw:track', { detail: payload })); } catch (e) {}
  }

  // expose for programmatic events
  window.awTrack = window.awTrack || push;

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-aw-event]');
    if (!el) return;
    var name = el.getAttribute('data-aw-event');
    if (!name || !name.trim()) return;
    // Optional payload params ride on data-awp-* attributes (data-awp-item-id -> item_id).
    // Kept on a separate prefix so behavioural data-aw-* hooks are not slurped in as params.
    var extra = null, attrs = el.attributes, i, a;
    for (i = 0; i < attrs.length; i++) {
      a = attrs[i];
      if (a.name.indexOf('data-awp-') === 0) {
        var k = a.name.slice(9).replace(/-/g, '_');
        if (k !== 'event') { (extra = extra || {})[k] = a.value; } // a param must never clobber the event name
      }
    }
    push(name.trim(), extra);
  }, true);
})();
